const BASE = 7;

const rotateWeekday = (skip, weekday) => {
  if (!Number.isSafeInteger(weekday)) return NaN;
  if (weekday < 0 || weekday > 6) return NaN;
  if (!Number.isSafeInteger(skip)) return weekday;

  const rotated = (weekday + skip) % BASE;

  // this extra step makes sure the result is positive number
  return (rotated + BASE) % BASE;
};

export default rotateWeekday;
